// extracted by mini-css-extract-plugin
export default {"project":"AssistantMessage_project__maPIC","project-lhs":"AssistantMessage_project-lhs__lmSO+","copyBtn":"AssistantMessage_copyBtn__X9qd2"};